<template>
    <div class="card border-0 bg-white profile-settings-card rounded-0">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
            <div class="row">
                <div class="col-12 mb-30">
                    {{ $t('feature.auth.$delete_account.disclaimer') }}
                </div>
                <div class="col-md-12">
                    <div class="d-flex align-items-center justify-content-end" v-if="!loading">
                        <!-- SAVE -->
                        <div class="d-flex flex-wrap gap-3 justify-content-end ms-auto">

                            <button
                                class="default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16"
                                @click="initRequest()">
                                {{ $t('page.delete_account') }}
                            </button>
                        </div>
                    </div>
                    <SpinnerLoading v-else />
                </div>
            </div>
        </div>
    </div>
    <!-- ERROR MESSAGE -->
    <div class="row justify-content-center">
        <div class="col">
            <div class="alert alert-danger alert-dismissible fade border-0 border-danger-subtle border-top rounded-0 m-0 mb-25"
                role="alert" id="errorMessage">
                <strong>{{ $t('error.something_went_wrong') }}</strong>
                <button type="button" class="btn-close" v-on:click="hideError" aria-label="Close"></button>
            </div>
        </div>
    </div>

    <AlertModal id="alertModal" :title="$t('feature.auth.delete_account')" :dismissible="false"
        :message="$t('feature.auth.$delete_account.success_message')" @confirm="redirect" />
    <ConfirmModal id="confirmModal" :title="$t('feature.auth.delete_account')"
        :message="$t('feature.auth.$delete_account.alert_message')" @confirm="sendRequest()" />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import { Alert, Modal } from "bootstrap";
import AlertModal from "@/components/Widgets/AlertModal.vue";
import ConfirmModal from "@/components/Widgets/ConfirmModal.vue";
import API from "@/services/api/api.service";

export default defineComponent({
    name: "RightToErasureForm",
    components: {
        AlertModal,
        ConfirmModal
    },
    data: function () {
        return {
            submitted: false,
            errorMessage: undefined as Alert | undefined,
            errors: undefined as any,
            alertModal: null as Modal | null,
            confirmModal: null as Modal | null,
            loading: false,
        }
    },
    mounted() {
        this.errorMessage = new Alert('#errorMessage');
        this.alertModal = new Modal('#alertModal', {});
        this.confirmModal = new Modal('#confirmModal', {});
    },
    methods: {
        showError() {
            const error = document.getElementById('errorMessage');
            error?.classList.add('show');
            setTimeout(() => {
                this.hideError();
            }, 5000)
        },
        hideError() {
            const error = document.getElementById('errorMessage');
            error?.classList.remove('show');
        },
        redirect() {
            this.$router.push('/logout');
        },
        initRequest() {
            this.confirmModal?.show();
        },
        sendRequest() {
            this.hideError();
            console.log('DELET_ACCOUNT');
            this.loading = true;
            this.errorMessage = undefined;
            API.deleteAccount().then((response) => {
                if (response.data.success === true) {
                    this.alertModal?.show();
                } else {
                    this.errorMessage = response.data.message;
                }
            }).catch((error) => {
                console.error('DELETE_ACCOUNT_ERROR', error);
                this.errorMessage = error.response?.data.message;
                this.showError();
            }).finally(() => {
                this.loading = false;
            });
        },
    }

});
</script>